import apiClient from './api_client_requests';
import { getCookieByName } from './cookies';

export default (config) => {
    return async (payload) => {
        let result = await apiClient(config).apiMethod({
            method: 'GetSweepDetails',
            headers: {},
            args: {},
            urlArgs: {
                sweeps_id: payload ? payload.sweeps_id : null,
            },
        });
        return result;
    };
};
